import axios from "./axios";

export const supplierinvoicesApi = {
  getSupplierInvoices: (params = {}) => {
    // Use projects/supplier-invoices endpoint if project_id is provided
    if (params.project_id) {
      return axios.get(`/projects/${params.project_id}/supplier-invoices`, { params });
    }
    // Use generic supplier invoices endpoint
    return axios.get("/supplier-invoices", { params });
  },

  getSupplierInvoice: (supplierInvoiceId, params = {}) => {
    return axios.get(`/supplier-invoices/${supplierInvoiceId}`, { params });
  },
};

export const fetchSupplierInvoices = async (params = {}) => {
  return supplierinvoicesApi.getSupplierInvoices(params)
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
};


